import React from "react";
import { connect } from "react-redux";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { ViewCarousel, Visibility } from "@mui/icons-material";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";

import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import Detail from "./Modals/Detail";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import TextFilter from "../../components/Filters/TextFilter";
import { format } from "date-fns";

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      detailModel: false,
      selectedId: null,
    };
  }

  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  handleDetailAction = (row) => {
    this.setState({
      selectedId: row[0],
      detailModel: true,
    });
  };

  handleCustomDatum = (item) => {
    return format(Date.parse(item?.delivery_timestamp), "dd-MM-yyyy HH:mm:ss");
  };

  render() {
    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Mail Log"} tKey={"maillog.pagetitle"} />} />

        <GridContainer>
          <GridItem md={6} xs={12}>
            <TextFilter
              field={"recipient"}
              fieldKey={"maillog:recipient"}
              operator={"like"}
              placeholder={getTranslation("maillog.filter.api", "Recipient")}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={[
                {
                  icon: Visibility,
                  tooltip: <TranslationWrapper tDefault={"Show details"} tKey={"maillog.table.tooltip.showDetails"} />,
                  action: this.handleDetailAction,
                },
              ]}
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "sender", editable: false },
                { dbfield: "recipient", editable: false },
                { dbfield: "status", editable: false },
                { customData: this.handleCustomDatum },
              ]}
              dbfields={"id,sender,recipient,status,delivery_timestamp"}
              fetchUrl={"core/maillog"}
              filters={this.props.filters}
              headerIcon={<ViewCarousel />}
              headers={[
                {
                  label: getTranslation("maillog.table.id", "#"),
                  sortable: false,
                },
                {
                  label: getTranslation("maillog.table.sender", "Sender"),
                  sortable: false,
                },
                {
                  label: getTranslation("maillog.table.recipient", "Recipiet"),
                  sortable: false,
                },
                {
                  label: getTranslation("maillog.table.status", "Status"),
                  sortable: false,
                },
                {
                  label: getTranslation("maillog.table.dt", "Delivery Time"),
                  sortable: false,
                },
              ]}
              reduxKey={"maillog"}
              showAutoRenew
              showRefresh
              tableTitle={<TranslationWrapper tDefault={"Maillog"} tKey={"maillog.table.titel"} />}
            />
          </GridItem>
        </GridContainer>

        <Detail
          apilogId={this.state.selectedId}
          open={this.state.detailModel}
          toggle={() => this.toggleModal("detailModel")}
        />
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  let filters = {};

  if (state.filtersV2["maillog:recipient"]) {
    filters["maillog:recipient"] = state.filtersV2["maillog:recipient"];
  }
  return {
    filters,
  };
};

export default connect(mapStateToProps)(withStyles(Index, tafelStyle));
